import httpClient from "@plugins/http";
import assignmentApi from "@apis/assignment.api";
import { getBrowserTabUuid } from "@utils/app.storage";

const fetchResourceLesson = (params) => {
  return httpClient.get(`/apis/class-group/lesson/${params.uuid}`);
};

const fetchResourceAssignment = (params) => {
  const uuid = params.uuid;
  delete params.uuid;
  return httpClient.get(`/apis/class-group/lesson/get-assignment/${uuid}`, {
    params: params,
  });
};

const allowStudentAccessResource = async (requestData) => {
  const params = new URLSearchParams();

  params.append("notifyStudents", requestData.notifyStudents);
  params.append("notificationMsg", requestData.notificationMsg || "");
  params.append("markAsIncomplete", requestData.markAsIncomplete);

  return await httpClient.post(`/apis/assignment/resume/${requestData.assignmentUuid}`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    params: {
      browserTabUuid: requestData.browserTabUuid,
    },
  });
};

const removeStudentAccessResource = async (assignmentUuid) => {
  return await httpClient.post(`/apis/assignment/pause/${assignmentUuid}`);
};

const deleteResource = (assignmentUuid) => {
  return assignmentApi.deleteAssignment(assignmentUuid, getBrowserTabUuid());
};

export default {
  fetchResourceLesson,
  fetchResourceAssignment,
  allowStudentAccessResource,
  removeStudentAccessResource,
  deleteResource,
};
